import { render, staticRenderFns } from "./EditorialIntro.vue?vue&type=template&id=5376a294&scoped=true"
import script from "./EditorialIntro.vue?vue&type=script&lang=js"
export * from "./EditorialIntro.vue?vue&type=script&lang=js"
import style0 from "./EditorialIntro.vue?vue&type=style&index=0&id=5376a294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376a294",
  null
  
)

export default component.exports